import React, { useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@material-ui/core";

const BODY_CLASS_ALERT_DIALOG_OPEN = "alert-dialog-open";

const AlertDialog = (props) => {
  
  useEffect(() => {
    if (props.open) {
      document.body.classList.add(BODY_CLASS_ALERT_DIALOG_OPEN);
    }
    return () => {
      document.body.classList.remove(BODY_CLASS_ALERT_DIALOG_OPEN);
    };
  }, [props.open]);

  const handleCloseTouchEnd = (e) => {
    e.preventDefault();
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography
              variant="h6"
              sx={{
                color: "success.main",
                fontSize: "20px",
              }}
              align="center"
            >
              {props.successMsg}
            </Typography>
            {props.subMsg ? (
              <Typography
                variant="body1"
                sx={{
                  color: "text.primary",
                  fontSize: "14px",
                  pt: 1,
                }}
              >
                {props.subMsg}
              </Typography>
            ) : (
              ""
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "background.paper",
              color: "text.primary",
            }}
            onClick={props.handleClose}
            onTouchEnd={handleCloseTouchEnd}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
